export default __webpack_public_path__ + "static/media/mascote-corpo.7db01652.webp";